<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
	<div class="relative">
		<div class="vx-navbar-wrapper" :class="classObj">
			<vs-navbar
				class="vx-navbar navbar-custom navbar-skelton o-navbar--vertical"
				:color="navbarColorLocal"
				:class="textColor"
			>
				<!-- SM - OPEN SIDEBAR BUTTON -->
				<feather-icon
					class="sm:inline-flex xl:hidden cursor-pointer pl-10"
					style="color: #f4710c"
					icon="MenuIcon"
					@click.stop="showSidebar"
				/>
				<company-brand class="ml-4" />
				<group-drop-down v-if="isBookMarkVisible && showGroupOnNavBar" class="hidden lg:block" />
				<vs-spacer />
				<!-- GEORREFERENCIADOR -->
				<georreferencer v-if="isBookMarkVisible"></georreferencer>
				<notification-rutify class="mr-2 ml-2" />
				<i18n />
				<profile-drop-down class="mr-6" />
			</vs-navbar>
		</div>
	</div>
</template>

<script>
import Bookmarks from "./components/Bookmarks.vue";
import I18n from "./components/I18n.vue";
import SearchBar from "./components/SearchBar.vue";
import CartDropDown from "./components/CartDropDown.vue";
import NotificationDropDown from "./components/NotificationDropDown.vue";
import ProfileDropDown from "./components/ProfileDropDown.vue";
import MapSettings from "@/components/Maps/MapSettings.vue";
import Georreferencer from "./components/Georreferencer.vue";
import NotificationRutify from "@/components/notifications/NotificationRutify.vue";
import CompanyBrand from "./components/CompanyBrand";
import GroupDropDown from "./components/GroupDropDown.vue";

export default {
	name: "the-navbar-vertical",
	props: {
		navbarColor: {
			type: String,
			default: "#fff",
		},
	},
	components: {
		CompanyBrand,
		Bookmarks,
		I18n,
		SearchBar,
		CartDropDown,
		NotificationDropDown,
		ProfileDropDown,
		MapSettings,
		Georreferencer,
		NotificationRutify,
		GroupDropDown,
	},
	data() {
		return {
			isBookMarkVisible: true,
		};
	},
	computed: {
		navbarColorLocal() {
			return this.$store.state.theme === "dark" && this.navbarColor === "#fff" ? "#10163a" : this.navbarColor;
		},
		verticalNavMenuWidth() {
			return this.$store.state.verticalNavMenuWidth;
		},
		textColor() {
			return {
				"text-orange":
					(this.navbarColor !== "#10163a" && this.$store.state.theme === "dark") ||
					(this.navbarColor !== "#fff" && this.$store.state.theme !== "dark"),
			};
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		// NAVBAR STYLE
		classObj() {
			if (this.verticalNavMenuWidth === "default") return "navbar-default";
			else if (this.verticalNavMenuWidth === "reduced") return "navbar-reduced";
			else if (this.verticalNavMenuWidth) return "navbar-full";
		},
		showGroupOnNavBar() {
			return this.$store.state.modulePreferences.show_default_group_tracking;
		},
	},
	methods: {
		showSidebar() {
			this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
		},
	},
	watch: {
		$route(to, from) {
			if (to.name !== "dashboard-maps") {
				this.isBookMarkVisible = false;
			} else {
				this.isBookMarkVisible = true;
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.vs-navbar.navbar-skelton {
	padding: 0;
}

.navbar-custom .vs-con-items {
	display: grid !important;
}
</style>
